"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Uploader = void 0;
var _react = require("react");
var _UploadButton = require("./Partials/UploadButton");
var _UploadDropZone = require("./Partials/UploadDropZone");
var _Uploader = require("./Uploader.styles");
var _Uploader2 = require("./Uploader.labels");
var _hooks = require("../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
const Uploader = props => {
  const getLabel = (0, _hooks.useLabels)({
    labels: _Uploader2.labels
  });
  const fileInputRef = (0, _react.useRef)(null);
  const [isDragOver, setIsDargOver] = (0, _react.useState)(false);
  const [errorMessage, setErrorMessage] = (0, _react.useState)('');
  const {
    layout = 'button',
    acceptedMimeTypes,
    maxFileSizeMB = 3,
    isDisabled,
    onFileSelected,
    onFileSizeError,
    onFileTypeError
  } = props;
  const inputAcceptanceTypes = (0, _react.useMemo)(() => acceptedMimeTypes?.length > 0 ? acceptedMimeTypes.map(mimeType => '.' + mimeType.toLowerCase().split('/')[1]).join(', ') : '', [acceptedMimeTypes]);
  const styles = (0, _Uploader.useStyles)(layout, isDragOver);
  const processFile = file => {
    const types = acceptedMimeTypes;
    const maxSize = 1024 * 1024 * maxFileSizeMB;
    if (!types.includes(file.type) && typeof onFileTypeError === 'function') {
      onFileTypeError(file.type);
      setErrorMessage(getLabel('uploader_type_error'));
    } else if (file.size < 100 || file.size > maxSize && typeof onFileSizeError === 'function') {
      setErrorMessage(getLabel('uploader_size_error'));
      onFileSizeError(file.size);
    } else {
      setErrorMessage('');
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        onFileSelected({
          file: file,
          fileData: reader.result
        });
      };
    }
  };
  const handleFileChange = () => {
    try {
      if (fileInputRef?.current?.files && fileInputRef.current.files.length > 0) {
        processFile(fileInputRef.current.files[0]);
      }
    } catch (ex) {
      console.error(ex);
    }
  };
  const handleDragOver = () => {
    if (isDisabled) return;
    setIsDargOver(true);
    if (layout === 'dropzone') {
      const {
        onDragOver
      } = props;
      if (onDragOver) {
        onDragOver();
      }
    }
  };
  const handleDragLeave = () => {
    if (isDisabled) return;
    setIsDargOver(false);
    if (layout === 'dropzone') {
      const {
        onDragLeave
      } = props;
      if (onDragLeave) {
        onDragLeave();
      }
    }
  };
  const handleFileDrop = event => {
    // Prevent default behavior (Prevent file from being opened)
    event.preventDefault();
    if (event.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      [...event.dataTransfer.items].forEach((item, i) => {
        // If dropped items aren't files, reject them
        if (item.kind === 'file') {
          const file = item.getAsFile();
          if (file) {
            processFile(file);
          }
        }
      });
    }
  };
  const handleButtonClick = event => {
    fileInputRef?.current?.click();
    if (layout === 'button') {
      const {
        onClick
      } = props;
      if (onClick) {
        onClick(event);
      }
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: layout === 'button' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_UploadButton.UploaderButton, {
      ...props,
      ref: fileInputRef,
      isDisabled: isDisabled,
      inputAcceptanceTypes: inputAcceptanceTypes,
      styles: styles,
      onFileChange: handleFileChange,
      onClick: handleButtonClick,
      errorMessage: errorMessage
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_UploadDropZone.UploadDropZone, {
      ...props,
      ref: fileInputRef,
      messagesGender: props.messagesGender,
      inputAcceptanceTypes: inputAcceptanceTypes,
      styles: styles,
      onDrop: handleFileDrop,
      onFileChange: handleFileChange,
      onDragOver: handleDragOver,
      onDragLeave: handleDragLeave,
      errorMessage: errorMessage
    })
  });
};
exports.Uploader = Uploader;